import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { TableParams } from '@supplement-bacon/sb-table-filters'
import { Cluster } from '../models/Cluster'
import { HomeSection } from '../models/HomeSection'
import { CLUSTERS_URL, SETTINGS_URL } from '../utils/urls'

const fetchClusters = (params: TableParams) =>
  SBAPI.FetchPaginated<Cluster[]>(CLUSTERS_URL, params)

const fetchClusterById = (id: number, params?: TableParams) =>
  SBAPI.Fetch<Cluster>(`${CLUSTERS_URL}/${id}`, params)

const createCluster = (cluster: Cluster) => SBAPI.Post(CLUSTERS_URL, cluster)

const updateCluster = (cluster: Cluster) =>
  SBAPI.Put(`${CLUSTERS_URL}/${cluster.id}`, cluster)

const deleteCluster = (cluster: Cluster) =>
  SBAPI.Delete(`${CLUSTERS_URL}/${cluster.id}`)

const fetchClosestClusterTitle = (): Promise<HomeSection> =>
  SBAPI.Fetch<HomeSection>(`${SETTINGS_URL}/home-section`).then(
    (data) => data.data
  )
const updateClosestClusterTitle = (homeSection: HomeSection) =>
  SBAPI.Put(`${SETTINGS_URL}/home-section`, homeSection)

export {
  createCluster,
  deleteCluster,
  fetchClosestClusterTitle,
  fetchClusterById,
  fetchClusters,
  updateClosestClusterTitle,
  updateCluster,
}
